import React from "react";
import Userlayout from "../Components/Userdashboard/Userlayout";

const Userdashboard = () => {
  return (
    <section>
      <Userlayout />
    </section>
  );
};

export default Userdashboard;
